// removed by extract-text-webpack-plugin
module.exports = {"optionTypeSwitcher":"_2O3OGc7BE3Tj-nvAcjwrcJ","optionTypeButton":"dzNl5NXkUokIvjaXjSXrQ","activeButton":"_2mysrwkt_dE656-QDohlD6","separator":"_3WGju2eRlWBjA6AItbNBzC"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RealtorUser/OptionTypeSwitcher/OptionTypeSwitcher.scss
// module id = 1764
// module chunks = 0